import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { useLocalStorage } from "../components/useLocalStorage";
import { Outlet, Link } from "react-router-dom";
import { useState } from "react";

const TextFieldStyle = { width: '100%' };

const AppBoardScreen = () => {
    const [NumeroDeTarjetanNameS, setNumeroDeTarjetanNameS] = useLocalStorage("NumeroDeTarjetanNameS", "");
    const [buttonStatus, setButtonStatus] = useState(false);  
    const inputChangeHandler = () => {
        setTimeout(() => {
            if (NumeroDeTarjetanNameS.length > 0 ) {
                setButtonStatus(true);
            } else {
                setButtonStatus(false);
            }    
        }, 100)
    };

    inputChangeHandler();

    return (
        <Box id="AppBoardScreen2" className="AppBoardScreen AppBoardScreen2" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/YourDmvFeesSeceond">
                        <Button variant="outlined" size="large">Back</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">Toma el pago</h2>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">Pago placas 1ABC123: $150 Envio normal: $44 Total: </h2>
                </Grid>
                <Grid item xs={12}>
                    <h4 className="subHeading">$194</h4>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">Informacion de la tarjeta</h2>
                </Grid>
                <Grid item xs={12}>
                    <TextField  onKeyUp={inputChangeHandler} onChange={(e) => setNumeroDeTarjetanNameS(e.target.value)} value= {NumeroDeTarjetanNameS} label="Numero de tarjeta" variant="outlined" sx={TextFieldStyle} />
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">Pais o region</h2>
                </Grid>
                <Grid item xs={12}>
                    <Link to="/dmv/cambio/RenovationCompletedShipmentGeneratedSeceond">
                        <Button disabled={!buttonStatus} variant="contained" color="success" size="large" sx={{ width: "50%" }}>Pagar  $194</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <Link to="/dmv/cambio/WeWereUnableProcessSecenod">
                        <Button disabled={!buttonStatus}  variant="contained" color="success" size="large" sx={{ width: "50%" }}>Test</Button>
                    </Link>
                </Grid>

                <Outlet/>
            </Grid>
        </Box>
    );
};

export default AppBoardScreen;